import { create } from "zustand";

export const useAppLayoutStore = create((set) => ({
    hideSidebar: false,
    setHideSidebar: (value) => set({ hideSidebar: value }),
}));
